import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=0204c452&"
import script from "./Load.vue?vue&type=script&lang=js&"
export * from "./Load.vue?vue&type=script&lang=js&"
import style0 from "./Load.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports